import React, { useEffect } from 'react';
import { SignUpReferralDynamicFormConnected } from '@d24/ui-lib';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import API from '../../services';
import MailboxIcon from '../../assets/img/rich_icons/mailbox.svg';
import { Routes as configRouter } from '../../config/Routes';
import ModalTypes from '../../components/Modal/ModalTypes';
import { hideModal, showModal } from '../../redux/actions/GlobalModalActions';
import { showError } from '../../redux/actions/GlobalToastActions';
import config from '../../envConfig/config';

const InternalDynamicReferralSignUp = (props) => {
  const { match, t, i18n, route, showModal, hideModal } = props;

  useEffect(() => {
    i18n.changeLanguage(match.params.language || 'es');
  }, [i18n, match.params.language]);

  const onSuccess = () => {
    if (window.parent) {
      window.parent.postMessage('success', '*');
    }
    showModal(
      {
        title: 'labelOlaClickSuccessfulRegistration',
        labelConfirm: 'labelSignUpOlaClickSuccess',
        secondLabelConfirm: 'labelSignUpOlaClickSuccessSubtitle',
        textBtnConfirm: 'buttonOlaClickContinue',
        mainIcon: MailboxIcon,
        headerIcon: 'check-circle',
        type: 'info',
        emailConfirmation: true,
        reverseButtons: false,
        disableCancel: true,
        loadingOnConfirm: true,
        onConfirm: () => {
          hideModal();
          route.history.push(configRouter.LOGIN);
        },
      },
      ModalTypes.CONFIRMATION_MODAL
    );
  };

  const getReferralId = () => {
    return new URLSearchParams(route.location.search).get('referralId');
  };

  const getExternalSubMerchantId = () => {
    return new URLSearchParams(route.location.search).get('externalSubMerchantId');
  };

  const getCountry = () => {
    return (match.params.country || match.path.split('/').pop()).toUpperCase();
  };

  const onError = (error) => {
    const { response = {} } = error;
    const msgError = (response.data && response.data.description) || t('labelNetworkError');
    showError(msgError);
    if (window.parent) {
      window.parent.postMessage('error', '*');
    }
  };

  return (
    <SignUpReferralDynamicFormConnected
      logo={config.REACT_APP_LOGO_URL.defaultLogo}
      name={config.REACT_APP_LOGO_URL.title}
      panelType={config.REACT_APP_PANEL_TYPE}
      api={API}
      mainMerchantId={match.params.mainMerchantId || getReferralId()}
      country={getCountry()}
      externalSubMerchantId={getExternalSubMerchantId()}
      onSuccess={onSuccess}
      onError={onError}
      mainMerchantType="OLACLICK"
      translator={t}
    />
  );
};

const mapDispatchToProps = (dispatch) => bindActionCreators({ showModal, hideModal, showError }, dispatch);

export const DynamicReferralSignUp = compose(
  withRouter,
  withNamespaces(),
  connect(() => ({}), mapDispatchToProps)
)(InternalDynamicReferralSignUp);
